
export default {
    name: "Pridel Document",
    meta: {
        icon: "directions_boat",
        expanded: true,
        auth: true,
    },
    departmentName: "Pridel Document",
    finalPagePermision: "",
    children: [
        {
            name: "Pridel Document",
            permissionName: 'Pridel Document',
            keywords: ['Pridel Document'],
            path: "/DocumentValidator",
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/masters/documentValidatorMaster.vue"),
            finalPagePermision: "Pridel Document",
        },
        {
            name: "Invoices Document",
            permissionName: 'Invoices Document',
            keywords: ['Invoices Document'],
            path: "/billInvList",
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/invoice/billingInvList.vue"),
            finalPagePermision: "Invoices Document",
        },
        {
            name: "Contract Master",
            permissionName: 'Contract Master',
            keywords: ['Contract Master'],
            path: "/console_booking/ContarctList",
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/consoleBooking/ContarctList.vue"),
            finalPagePermision: "Contract Master",
        },
    ],
};


// WEBPACK FOOTER //
// ./src/sidebar/document.js